import {generateAsyncActionCreators} from '../core/reduxUtils';

const getHomePageComponentsActionCreators = generateAsyncActionCreators(
  'GET_HOME_PAGE_COMPONENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getCmsHomePageComponentsActionCreators = generateAsyncActionCreators(
  'GET_CMS_HOME_PAGE_COMPONENTS',
  (params) => ({
    params,
  }),
);

const getHomepageComponentsWithBannerListActionCreators = generateAsyncActionCreators(
  'GET_HOMEPAGE_COMPONENTS_WITH_BANNER_LIST',
  (homepageComponents, params, userId, anonymousId, isPersonalizationEnabled, isLocationAwareAvailable, isCustomerInfoEnabled) => ({
    homepageComponents,
    params,
    userId,
    anonymousId,
    isPersonalizationEnabled,
    isLocationAwareAvailable,
    isCustomerInfoEnabled,
  }),
);

const actionCreators = {
  getHomePageComponents: {
    ...getHomePageComponentsActionCreators,
  },
  getCmsHomePageComponents: {
    ...getCmsHomePageComponentsActionCreators,
  },
  getHomepageComponentsWithBannerList: {
    ...getHomepageComponentsWithBannerListActionCreators
  },
};

export {
  actionCreators,
  getHomePageComponentsActionCreators,
  getCmsHomePageComponentsActionCreators,
  getHomepageComponentsWithBannerListActionCreators,
};
